module.exports = __webpack_public_path__ + "img/124.7.f2b273b1.png";